import { render, staticRenderFns } from "./DoctorMonthOverview.vue?vue&type=template&id=4ae4ff53&scoped=true"
import script from "./DoctorMonthOverview.vue?vue&type=script&lang=js"
export * from "./DoctorMonthOverview.vue?vue&type=script&lang=js"
import style0 from "./DoctorMonthOverview.vue?vue&type=style&index=0&id=4ae4ff53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae4ff53",
  null
  
)

export default component.exports